import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoOpsCenter = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "a",
	"data-name": "Layer 2",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 377.85 108.73",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "b",
		"data-name": "Layer 1-2",
		children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			d: "m0,.63v106.26h106.26V.63H0Zm91.08,91.08H15.18V15.81h75.9v75.9Z",
			style: {
				fill: "currentColor",
				strokeWidth: 0
			}
		}), /* @__PURE__ */ _jsx("polygon", {
			points: "83.49 68.94 37.95 68.94 37.95 38.58 68.31 38.58 68.31 53.76 83.49 38.58 83.49 23.4 22.77 23.4 22.77 84.12 83.49 84.12 83.49 68.94",
			style: {
				fill: "currentColor",
				strokeWidth: 0
			}
		})] }), /* @__PURE__ */ _jsxs("g", {
			style: { isolation: "isolate" },
			children: [/* @__PURE__ */ _jsxs("g", {
				style: { isolation: "isolate" },
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "m161.71,49.71c-8.8.79-16.1,1.18-21.9,1.18-3.87,0-6.71-.91-8.52-2.72-1.81-1.81-2.72-4.65-2.72-8.52v-18.94c0-4.14.94-7.15,2.81-9.03,1.87-1.87,4.88-2.81,9.02-2.81h21.3v8.29h-18.94c-2.37,0-3.55,1.18-3.55,3.55v18.94c0,.91.27,1.63.8,2.16.53.53,1.21.8,2.04.8s1.74,0,2.72-.03c.99-.02,2.01-.05,3.08-.09,1.07-.04,2.14-.08,3.23-.12,1.08-.04,2.49-.12,4.2-.24s3.86-.26,6.42-.41v7.99Z",
						style: {
							fill: "currentColor",
							strokeWidth: 0
						}
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "m173.84,50.3h-11.54l15.68-41.43h11.84l15.68,41.43h-11.54l-2.66-7.4h-14.79l-2.66,7.4Zm5.33-15.09h9.47l-4.73-13.91-4.73,13.91Z",
						style: {
							fill: "currentColor",
							strokeWidth: 0
						}
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "m208.46,8.87h24.86c4.14,0,7.15.94,9.03,2.81,1.87,1.88,2.81,4.88,2.81,9.03v5.33c0,3.28-.54,5.82-1.63,7.63-1.09,1.82-2.81,3.02-5.18,3.61l7.4,13.02h-11.54l-6.81-12.43h-8.29v12.43h-10.65V8.87Zm26.04,11.84c0-2.37-1.18-3.55-3.55-3.55h-11.84v12.43h11.84c2.37,0,3.55-1.18,3.55-3.55v-5.33Z",
						style: {
							fill: "currentColor",
							strokeWidth: 0
						}
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "m251.07,8.87h23.67c3.87,0,6.71.88,8.52,2.63,1.81,1.76,2.72,4.43,2.72,8.02,0,2.37-.51,4.29-1.54,5.77-1.03,1.48-2.29,2.52-3.79,3.11,3.2.87,5.37,3,6.51,6.39.39,1.22.59,2.64.59,4.26,0,3.87-.91,6.71-2.72,8.52-1.81,1.82-4.66,2.72-8.52,2.72h-25.45V8.87Zm24.26,11.84c0-2.37-1.18-3.55-3.55-3.55h-10.06v8.29h10.06c2.37,0,3.55-1.18,3.55-3.55v-1.18Zm1.78,16.57c0-2.37-1.18-3.55-3.55-3.55h-11.84v8.29h11.84c2.37,0,3.55-1.18,3.55-3.55v-1.18Z",
						style: {
							fill: "currentColor",
							strokeWidth: 0
						}
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "m330.37,39.06c0,4.14-.94,7.15-2.81,9.02-1.87,1.88-4.88,2.81-9.03,2.81h-14.79c-4.14,0-7.15-.94-9.02-2.81-1.88-1.87-2.81-4.88-2.81-9.02v-18.94c0-4.14.94-7.15,2.81-9.03s4.88-2.81,9.02-2.81h14.79c4.14,0,7.15.94,9.03,2.81,1.87,1.88,2.81,4.88,2.81,9.03v18.94Zm-10.65-18.94c0-2.37-1.18-3.55-3.55-3.55h-10.06c-2.37,0-3.55,1.18-3.55,3.55v18.94c0,2.37,1.18,3.55,3.55,3.55h10.06c2.37,0,3.55-1.18,3.55-3.55v-18.94Z",
						style: {
							fill: "currentColor",
							strokeWidth: 0
						}
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "m372.39,50.3h-11.24l-14.2-24.86v24.86h-10.65V8.87h11.24l14.2,24.86V8.87h10.65v41.43Z",
						style: {
							fill: "currentColor",
							strokeWidth: 0
						}
					})
				]
			}), /* @__PURE__ */ _jsxs("g", {
				style: { isolation: "isolate" },
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "m153.46,90.2c0,2.77-.63,4.77-1.88,6.03-1.25,1.25-3.26,1.88-6.03,1.88h-9.88c-2.77,0-4.77-.63-6.03-1.88-1.25-1.25-1.88-3.26-1.88-6.03v-12.64c0-2.77.62-4.77,1.88-6.03,1.25-1.25,3.26-1.88,6.03-1.88h9.88c2.77,0,4.77.63,6.03,1.88,1.25,1.25,1.88,3.26,1.88,6.03v12.64Zm-7.11-12.64c0-1.58-.79-2.37-2.37-2.37h-6.72c-1.58,0-2.37.79-2.37,2.37v12.64c0,1.58.79,2.37,2.37,2.37h6.72c1.58,0,2.37-.79,2.37-2.37v-12.64Z",
						style: {
							fill: "currentColor",
							strokeWidth: 0
						}
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "m157.41,70.05h16.59c2.77,0,4.77.63,6.03,1.88,1.25,1.25,1.88,3.26,1.88,6.03v3.95c0,2.77-.63,4.77-1.88,6.03-1.25,1.25-3.26,1.88-6.03,1.88h-9.48v7.9h-7.11v-27.66Zm17.38,7.9c0-1.58-.79-2.37-2.37-2.37h-7.9v8.69h7.9c1.58,0,2.37-.79,2.37-2.37v-3.95Z",
						style: {
							fill: "currentColor",
							strokeWidth: 0
						}
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "m184.64,91.98c7.22.39,12.1.59,14.66.59.61,0,1.09-.18,1.44-.53s.53-.84.53-1.44v-3.56h-9.09c-2.77,0-4.77-.62-6.03-1.88-1.25-1.25-1.88-3.26-1.88-6.03v-1.19c0-2.77.63-4.77,1.88-6.03,1.25-1.25,3.26-1.88,6.03-1.88h13.87v5.53h-12.29c-1.58,0-2.37.79-2.37,2.37v.79c0,1.58.79,2.37,2.37,2.37h7.11c2.58,0,4.48.61,5.69,1.82,1.21,1.21,1.82,3.11,1.82,5.69v1.98c0,2.58-.61,4.48-1.82,5.69s-3.11,1.82-5.69,1.82c-1.34,0-2.77-.03-4.27-.08l-3.63-.16c-2.69-.13-5.47-.32-8.34-.55v-5.33Z",
						style: {
							fill: "currentColor",
							strokeWidth: 0
						}
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "m245.12,97.31c-5.87.53-10.75.79-14.62.79-2.58,0-4.48-.61-5.69-1.82s-1.82-3.11-1.82-5.69v-12.64c0-2.77.62-4.77,1.88-6.03,1.25-1.25,3.26-1.88,6.03-1.88h14.22v5.53h-12.64c-1.58,0-2.37.79-2.37,2.37v12.64c0,.61.18,1.09.53,1.44s.81.53,1.36.53,1.16,0,1.82-.02c.66-.01,1.34-.03,2.05-.06.71-.03,1.43-.05,2.15-.08s1.66-.08,2.81-.16,2.57-.17,4.29-.28v5.33Z",
						style: {
							fill: "currentColor",
							strokeWidth: 0
						}
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "m270.21,97.71h-21.93v-27.66h21.93v5.53h-14.82v5.33h11.66v5.53h-11.66v5.73h14.82v5.53Z",
						style: {
							fill: "currentColor",
							strokeWidth: 0
						}
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "m297.47,97.71h-7.51l-9.48-16.59v16.59h-7.11v-27.66h7.51l9.48,16.59v-16.59h7.11v27.66Z",
						style: {
							fill: "currentColor",
							strokeWidth: 0
						}
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "m315.65,97.71h-7.11v-22.13h-8.3v-5.53h23.71v5.53h-8.3v22.13Z",
						style: {
							fill: "currentColor",
							strokeWidth: 0
						}
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "m348.64,97.71h-21.93v-27.66h21.93v5.53h-14.82v5.33h11.66v5.53h-11.66v5.73h14.82v5.53Z",
						style: {
							fill: "currentColor",
							strokeWidth: 0
						}
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "m351.8,70.05h16.59c2.77,0,4.77.63,6.03,1.88,1.25,1.25,1.88,3.26,1.88,6.03v3.56c0,2.19-.36,3.89-1.09,5.1-.72,1.21-1.88,2.02-3.46,2.41l4.94,8.69h-7.7l-4.54-8.3h-5.53v8.3h-7.11v-27.66Zm17.38,7.9c0-1.58-.79-2.37-2.37-2.37h-7.9v8.3h7.9c1.58,0,2.37-.79,2.37-2.37v-3.56Z",
						style: {
							fill: "currentColor",
							strokeWidth: 0
						}
					})
				]
			})]
		})] })
	})
});
export default SvgLogoOpsCenter;
